import React from 'react';
import bowser from 'yola-bowser';
import classNames from 'classnames';
import Render from '../render';
import Icon from '../icon';
import { Menu, MenuItem } from '../menu';
import { Dropdown, DropdownTrigger, DropdownContent } from '../dropdown';
import { ListItem } from './constants/types';
import stopPropagation from '../utils/stop-propagation';

function TreeViewActions({ item }) {
  const { actions } = item;
  const isMobile = Boolean(bowser.mobile || bowser.tablet);
  const actionListClass = classNames('ws-tree-view-actions__controls', {
    'ws-tree-view-actions__controls--mobile': isMobile,
    'ws-tree-view-actions__controls--desktop': !isMobile,
  });

  return (
    <div className="ws-tree-view-actions">
      <div className={actionListClass}>
        <Render if={!isMobile}>
          {actions.map((action) => (
            <Icon
              size="14"
              key={action.title}
              glyph={action.glyph}
              data-tip={action.title}
              data-for={item.id.toString()}
              onClick={action.onClick}
            />
          ))}
        </Render>

        <Render if={isMobile}>
          <Dropdown dropOn="click" drop="left-top" onClick={stopPropagation}>
            <DropdownTrigger>
              <Icon glyph="more-vertical" />
            </DropdownTrigger>
            <DropdownContent>
              <Menu>
                {actions.map((action) => (
                  <MenuItem onClick={action.onClick} key={action.title}>
                    {action.title}
                  </MenuItem>
                ))}
              </Menu>
            </DropdownContent>
          </Dropdown>
        </Render>
      </div>
    </div>
  );
}

TreeViewActions.propTypes = {
  item: ListItem.isRequired,
};

export default TreeViewActions;
